import request from '/@common/utils/request';

//获取邮箱验证
export function getEmailCode(params: object) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/user/sendEmailCode`,
		// url: '/api/sms/send',
		method: 'post',
		data: params,
	});
}
//提交个人信息
export function bindUserInfo(params: object) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/user/bindUserInfo`,
		method: 'post',
		data: params,
	});
}
/**
 * @description: 获取模型调用次数
 */
export function getModelInvokeCount(modelVersion: string) {
	return request({
		url: `/api/dialogue/getModelInvokeCount/${modelVersion}`,
		method: 'get',
	});
}
//首次短信登录设置密码
export function initPwd(data: object) {
	return request({
		url: '/api/auth/initPwd',
		method: 'post',
		data,
	});
}
//管理员设置密码
export function setPassword(data: object) {
	return request({
		url: '/api/manager/setPassword',
		method: 'post',
		data,
	});
}
//管理员登录
export function adminLogin(data: object) {
	return request({
		url: '/api/manager/login',
		method: 'post',
		data,
	});
}
export function isRequireNoticeVersionUpdate() {
	return request({
		url: '/api/notice/isRequireNoticeVersionUpdate',
		method: 'get',
	});
}
export function create(data: object) {
	return request({
		url: '/api/share/create',
		method: 'post',
		data,
	});
}
export function record(data: object) {
	return request({
		url: '/api/share/record',
		method: 'get',
		params: data,
	});
}
export function continueConversation(data: object) {
	return request({
		url: '/api/share/continueConversation',
		method: 'post',
		data,
	});
}

export function dialogueTaskDateil(taskId: string) {
	return request({
		url: `/api/dialogueTask/detail/${taskId}`,
		method: 'get',
	});
}
export function updateDialogueTaskInfos(data:object){
	return request({
		url: `/api/dialogueTask/updateDialogueTaskInfos`,
		method: 'post',
		data
	});
}
export function pageDialogueTaskInfos(data: object) {
	return request({
		url: '/api/dialogueTask/pageDialogueTaskInfos',
		method: 'get',
		params: data,
	});
}
export function downloadFile(data:object){
	return request({
		url: `/api/dialogueTask/downloadFile`,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'post',
		data,
		responseType:'blob',
	});
}
export function downloadGuestFile(data:object){
	return request({
		url: `/api/guest/dialogueTask/downloadFile`,
		headers: { 'Content-Type': 'multipart/form-data' },
		method: 'post',
		data,
		responseType:'blob',
	});
}
export function updateCollectStatusByTask(id:string,isCollect){
	return request({
		url: `/api/dialogueTask/updateCollectStatus/${id}?isCollect=${isCollect}`,
		method:'put'
	});
}
export function createShareTask(data:object){
	return request({
		url: `/api/shareDialogueTask/create`,
		method:'post',
		data
	});
}
export function deleteTaskInfo(id:string){
	return request({
		url: `/api/dialogueTask/deleteTaskInfo/${id}`,
		method: 'delete',
	});
}

export function recordByTask(data: object) {
	return request({
		url: '/api/shareDialogueTask/record',
		method: 'get',
		params: data,
	});
}
export function dialogueGuestTaskDateil(taskId: string) {
	return request({
		url: `/api/guest/dialogueTask/detail/${taskId}`,
		method: 'get',
	});
}
export function shareDialogueTaskDeatil(taskId: string) {
	return request({
		url: `/api/shareDialogueTask/detail/${taskId}`,
		method: 'get',
	});
}
export function getBaseModels() {
	return request({
		url: `/api/dialogue/getBaseModels`,
		method: 'get',
	});
}
//获取文档解析结果
export function listDocumentParseResult(id:string) {
	return request({
		url: `/api/dialogue/listDocumentParseResult/${id}`,
		method: 'get',
	});
}
//获取游客文档解析结果
export function listGuestDocumentParseResult(id:string) {
	return request({
		url: `/api/guest/listDocumentParseResult/${id}`,
		method: 'get',
	});
}
export function getUniqueId() {
	return request({
		url: `/api/dialogue/uniqueId`,
		method: 'get',
	});
}

export function weiXinBindPhoneNumberNew (data: object) {			
	return request({
		url: '/api/sso/auth/weiXinBindPhoneNumber',
		method: 'post',
		data,
	});
}
	// 微信绑定手机号
	export function weiXinBindPhoneNumber (data: object) {			
		return request({
			url: '/api/user/weiXinBindPhoneNumber',
			method: 'post',
			data,
		});
	}
		// 获取验证码
		export function getPhoneCode (params: object) {
			return request({
				url: '/api/sms/send',
				method: 'post',
				params,
			});
		}
		export function loginMobile (data: object) {
			return request({
				url: '/api/chatLogin/login',
				method: 'post',
				data,
			});
		}
		export function listAppExampleQuestion(data: object) {
			return request({
				url: '/api/app/listAppExampleQuestion',
				method: 'get',
				params: data,
			});
		}



// 获取已经选择领域和关键词
export function subscriptions() {
	return request({
		url: `/api/profileTopics/subscriptions`,
		method: 'get',
	});
}

// 获取全部领域
export function categories() {
	return request({
		url: '/api/profileTopics/categories',
		method: 'get',
		
	});
}

export function saveOrUpdateUserPreference(data:object) {
	return request({
		url: `/api/userPreference/saveOrUpdateUserPreference`,
		method: 'post',
		data
	});
}

// 批量添加学者的领域
export function addFollowedTopics(data: object) {
	return request({
		url: `/api/lit/scientisthome/bindTopics`,
		method: 'post',
		data
	});
}

export function getCaseDetailTypeInfo() {
	return request({
		url: `/api/lit/cases/getCaseDetailTypeInfo`,
		method: 'get',
	});
}
export function getAppExampleDetails() {
	return request({
		url: `/api/appRole/getAppExampleDetails`,
		method: 'get',
	});
}
export function getCategories() {
	return request({
		url: `/api/lit/common/categories`,
		method: 'get',
	});
}
export function getSearchEnginesListOrMcpServerListByCategoryIdAndMode(data: object) {
	return request({
		url: `/api/lit/common/getSearchEnginesListOrMcpServerListByCategoryIdAndMode`,
		method: 'post',
		data
	});
}
export function searchKnowledgeBaseList() {
	return request({
		url: `/api/lit/common/searchKnowledgeBaseList`,
		method: 'get',
	});
}
export function isRequireBannerVersionUpdate() {
	return request({
		url: `/api/notice/isRequireBannerVersionUpdate`,
		method: 'get',
	});
}
export function updateBannerVersionStatus() {
	return request({
		url: `/api/notice/updateBannerVersionStatus`,
		method: 'get',
	});
}
export function getRunningDialogueTaskList() {
	return request({
		url: `/api/dialogue/getRunningDialogueTaskList`,
		method: 'get',
	});
}
export function saveUserKnowledgeBaseList(data: object) {
	return request({
		url: `/api/lit/common/saveUserKnowledgeBaseList`,
		method: 'post',
		data
	});
}
export function saveSearchEngineAndMcpList(data: object) {
	return request({
		url: `/api/lit/common/saveSearchEngineAndMcpList`,
		method: 'post',
		data
	});
}

export function getNewAppExampleDetails(data:object) {
	return request({
		url: `/api/appRole/v2/getAppExampleDetails`,
		method: 'get',
		params: data
	});
}
export function batchDelete(data:object){
	return request({
		url: `/api/dialogue/delChatImgList`,
		method: 'delete',
		data
	});
}

// 获取消息数据
export function readPageList(data: object) {
	return request({
		url: `/api/lit/message/readPageList`,
		method: 'post',
		data
	});
}
// 实时推送 轮询
export function pushPageList(data: object) {
	return request({
		url: `/api/lit/message/pushPageList`,
		method: 'post',
		data
	});
}

export function markAsRead(data: object) {
	return request({
		url: `/api/lit/message/markAsRead`,
		method: 'get',
		params: data,
	});
}

export function markAsReadBatch() {
	return request({
		url: `/api/lit/message/markAsReadBatch`,
		method: 'get'
	});
}
export function thirdOrgInfo(data: object) {
	return request({
		url:'/api/open/oauth2/auth/thirdOrgInfo',
		method: 'post',
		data
	})
}
export function searchUniqs(value: string) {
	return request({
		url: '/api/org/list?keyword=' + value,
		method: 'get',
	});
}

export function authorize(data: object) {
	return request({
		url: `/api/open/oauth2/auth/authorize`,
		method: 'post',
		data
	});
}
export function bind(data: object) {
	return request({
		url: `/api/open/oauth2/auth/bind`,
		method: 'post',
		data
	});
}
export function getLoginConfig() {
	return request({
		url: `/api/s1/tenant/config`,
		method: 'get',
	});
}

export function getSms(data: object) {
	return request({
		url: `/api/sms/send`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		method: 'post',
		data
	});
}
export function sendPwdRetrieveCode(data: object) {
	return request({
		url: `/api/user/sendPwdRetrieveCode`,
		method: 'post',
		data
	});
}
export function validatePwdRetrieveCode(data: object) {
	return request({
		url: `/api/user/validatePwdRetrieveCode`,
		method: 'post',
		data
	});
}
export function resetPassword(data: object) {
	return request({
		url: `/api/user/resetPassword`,
		method: 'post',
		data
	});
}
export function health() {
	return request({
		url: `/api/user/health`,
		method: 'get',
	});
}
// 获取当前用户邀请的邀请码信息
export function getUserInviteCode() {
	return request({
		url: `/admin/api/user-invite/getUserInviteCode`,
		method: 'get',
	});
}

// 获取当前用户邀请历史
export function getUserInviteList(data: object) {
	return request({
		url: `/admin/api/user-invite/getUserInviteList`,
		method: 'get',
		params: data,
	});
}
//  redeem 权益兑换
export function redeemInviteCode(data: object) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/s1/tenant/activity/redeem/code`,
		method: 'post',
		data
	});
}
// 获取用户权益兑换（兑换码）历史
export function getUserInviteRedeemHistory(data: object) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/s1/tenant/activity/redeem/history`,
		method: 'get',
		params: data,
	});
}

//查询用户研值（积分）余额
export function getUserPintsQuotaBalance(data: object) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/user-points-quota/getUserPintsQuotaBalance`,
		method: 'get',
		params: data,
	});
}
// 查询兑换码是否已兑换
export function checkRedeemCode(code: Number | String) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/s1/tenant/activity/valid/${code}`,
		method: 'get',
	});
}
//查询用户套餐列表
export function getUserPlanList() {
	return request({
		url: `${window.$website.ADMIN_URL}/api/user-points-quota/getUserPlanList`,
		method: 'get',
	});
}

// 文件上传
export function uploadChatFileWos(data: object, cancelToken: CancelToken) {
	return request({
		url: '/api/dialogue/uploadChatFileWos',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		cancelToken
	});
}
export function delWosFile(data: object) {
	return request({
		url: '/api/dialogue/delWosFile',
		method: 'delete',
		data,
	});
}

// 获取用户签到信息
export function getUserCheckinInfo(timeStamp:any) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/checkin/continuous`,
		method: 'get',
		params: timeStamp,
	});
}
// 用户签到
export function checkin(timeStamp:any) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/checkin`,
		method: 'get',
		params: timeStamp,
	});
}
// 查询签到记录（按时间范围）
export function getCheckinStatus(data: object) {
	return request({
		url: `/api/checkin/status`,
		method: 'post',
		data: data,
	});
}
// 查询用户新手任务列表数据
export function getUserNoviceTaskList() {
	return request({
		url: `/api/novice/list`,
		method: 'get',
	});
}
// 查询用户累计签到次数及获取的积分
export function userCheckinTotal() {
	return request({
		url: `/api/checkin/total`,
		method: 'get',
	});
}

// 获取新手任务列表
export function noviceList() {
	return request({
		url: `${window.$website.ADMIN_URL}/api/novice/list`,
		method: 'get',
	});
}
// 获取问卷调查列表
export function questionnaire(verson) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/questionnaire/fill?&version=${verson}`,
		method: 'get',
	});
}
// 提交问卷调查
export function submit(data: object) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/questionnaire/submit`,
		method: 'post',
		data
	});
}
// 查询是否今日首次登录提示签到
export function isFristLoginCheckin() {
	return request({
		url: `${window.$website.ADMIN_URL}/api/checkin/fristLogin`,
		method: 'get',
	});
}
// 查询用户今日签到状态
export function todayCheckinStatus() {
	return request({
		url: `${window.$website.ADMIN_URL}/api/checkin/todayStatus`,
		method: 'get',
	});
}
// 查询用户任务上新状态
export function noviceTaskChange() {
	return request({
		url: `${window.$website.ADMIN_URL}/api/novice/noviceTaskChange`,
		method: 'get',
	});
}
// 查询用户任务上新状态
export function recordBusTypeClick(busType) {
	return request({
		url: `${window.$website.ADMIN_URL}/api/novice/recordBusTypeClick/${busType}`,
		method: 'get',
	});
}
// 获取技能列表
export function getSkillList() {
	return request({
		url: '/api/common/skill/list',
		method: 'get',
	});
}
export function setLanguage(language: string) {
	return request({
		url: `/admin/api/user/changeUserLanguage/${language}`,
		method: 'put',
	});
}